import { IdNameEntity } from './IdNameEntity'

class NewsCategory extends IdNameEntity {
    constructor({ id, name }) {
        super({ id, name })
    }
}

export { NewsCategory }
